import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from '../layouts/loader/Loadable';
import Login from '../pages/Auth/Login';
import ForgotPassword from '../pages/Auth/ForgotPassword';
import AddDefectTestPage from '../pages/AddDefectTestPage';
import LuggageRackList from '../pages/furnishing/StageAuditFormat/VB/LuggageRackList';
//import TractionView from '../pages/electrical/VB/TractionView';
// import UfTrainType from '../pages/master/UfTrainType';
// import VisualType from '../pages/master/VisualTypesList';

// import UserList from '../pages/user/userList';

// import Dashboard from '../pages/dashboard/Dashboard';

/****Layouts*****/

const FullLayout = Loadable(lazy(() => import('../layouts/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/BlankLayout')));
/***** Pages ****/

//------------------------------------------------- real time links ---------------------------------------------
const DailyTurnOutReport = Loadable(lazy(() => import('../pages/master/DailyOutTurnReport')));
const UfTrainType = Loadable(lazy(() => import('../pages/master/UfTrainType')));
const VisualType = Loadable(lazy(() => import('../pages/master/VisualTypesList')));
const UserList = Loadable(lazy(() => import('../pages/user/userList')));
const RoofDimensionList = Loadable(lazy(() => import('../pages/master/RoofDimensionList')));
const MaterialList = Loadable(lazy(() => import('../pages/master/MaterialList')));
const UfVisualOBS = Loadable(lazy(() => import('../pages/master/UfVisualOBS')));
const UfCrossMember = Loadable(lazy(() => import('../pages/master/UfCrossMember')));
const UfComponentNames = Loadable(lazy(() => import('../pages/master/UfComponentNames')));
const UfMachineNames = Loadable(lazy(() => import('../pages/master/UfMachineNames')));
const UfOperationNames = Loadable(lazy(() => import('../pages/master/UfOperationsName')));
const UfOperations = Loadable(lazy(() => import('../pages/master/UfOperations')));
const MetalSheetList = Loadable(lazy(() => import('../pages/metalSheet/MetalSheetList')));
const RolePermissionList = Loadable(lazy(() => import('../pages/roles/RoleManagement')));
const RolePermissionEdit = Loadable(lazy(() => import('../pages/roles/RolePermissionEdit')));
const StageOneList = Loadable(lazy(() => import('../pages/stage/stageOne/StageOneList')));
const UfFrameTypes = Loadable(lazy(() => import('../pages/master/UfFrameTypes')));
const DrgNumbers = Loadable(lazy(() => import('../pages/master/DrgNumbers')));
const Instruments = Loadable(lazy(() => import('../pages/master/InstrumentNames')));
const StageTwoList = Loadable(lazy(() => import('../pages/stage/stageTwo/StageTwoList')));
const RoofStageOneList = Loadable(lazy(() => import('../pages/stage/roof/StageOneList')));
const RoofStageTwoList = Loadable(lazy(() => import('../pages/stage/roof/StageTwoList')));
const RoofStageThreeList = Loadable(lazy(() => import('../pages/stage/roof/StageThreeList')));
const EndWallStageOneList = Loadable(lazy(() => import('../pages/stage/endWall/StageOneList')));
const EndWallStageTwoList = Loadable(lazy(() => import('../pages/stage/endWall/StageTwoList')));
const SideWallStageOneList = Loadable(lazy(() => import('../pages/stage/sideWall/StageOneList')));
const SideWallStageTwoList = Loadable(lazy(() => import('../pages/stage/sideWall/StageTwoList')));
const SideWallStageThreeList = Loadable(
  lazy(() => import('../pages/stage/sideWall/StageThreeList')),
);
const AssemblyStageOneList = Loadable(lazy(() => import('../pages/stage/assembly/StageOneList')));
const AssemblyStageThreeList = Loadable(
  lazy(() => import('../pages/stage/assembly/StageThreeList')),
);
const FinalInspectionList = Loadable(
  lazy(() => import('../pages/stage/finalInspection/FinalInspectionList')),
);
const Dashboard = Loadable(lazy(() => import('../pages/dashboard/Dashboard')));
const ShellDashboard = Loadable(lazy(() => import('../pages/dashboard/ShellDashboard')));

const BogieDashboard = Loadable(lazy(() => import('../pages/dashboard/BogieDashboard')));
const WheelDashboard = Loadable(lazy(() => import('../pages/dashboard/WheelDashboard')));
const FurnishingDashboard = Loadable(lazy(() => import('../pages/dashboard/FurnishingDashboard')));

// CR position form
const CrPositionForm = Loadable(lazy(() => import('../pages/master/CrPositionForm')));

//------------------------------- paint -----------------------------------------------------
const PaintList = Loadable(lazy(() => import('../pages/paintShopInspection/Paint/PaintList')));
const PaintShopReport = Loadable(
  lazy(() => import('../pages/paintShopInspection/Paint/PaintReport')),
);
const PaintInsulationList = Loadable(
  lazy(() => import('../pages/paintShopInspection/Paint/PaintInsulationList')),
);
const PaintshopDashboard = Loadable(
  lazy(() => import('../pages/dashboard/paintShop/PaintshopDashboard')),
);

//------------------------------- Report -----------------------------------------------------
const ReportList = Loadable(lazy(() => import('../pages/report/ReportList')));
const ShellReport = Loadable(lazy(() => import('../pages/report/ShellReport')));
const FrontPart = Loadable(lazy(() => import('../pages/dailyReport/FrontPartInspections')));
const ShowerTesting = Loadable(lazy(() => import('../pages/dailyReport/ShowerTestingInspections')));
const LavSideWall = Loadable(lazy(() => import('../pages/dailyReport/LavSideWall')));

const MonthlyReportList = Loadable(lazy(() => import('../pages/report/MonthlyReport')));
const MonthlyInspectionReport = Loadable(lazy(() => import('../pages/report/MonthlyInspectionReport')));
const CrPositionReportList = Loadable(lazy(() => import('../pages/report/CrPositionReport')));
const AddDefectForm = Loadable(lazy(() => import('../components/AddDefectForm')));
//const InspectionReport = Loadable(lazy(() => import('../pages/furnishing/StageAuditFormat/VB/InspectionReport')));
const DailyDispatchReport = Loadable(lazy(() => import('../pages/report/DailyDispatchList')));
const WheelReport = Loadable(lazy(() => import('../pages/report/WheelReport')));
const StageInspectionShellReport = Loadable(
  lazy(() => import('../pages/report/StageInspectionShellReport')),
);
const QFRPreceilingList = Loadable(lazy(() => import('../pages/report/QFRPreceilingList')));
const QFRFinalQualityList = Loadable(lazy(() => import('../pages/report/QFRFinalQualityList')));
const BacklogReportList = Loadable(lazy(() => import('../pages/report/BacklogReport')));
const ShellVitalPointsReport = Loadable(lazy(() => import('../pages/report/ShellVitalPointReport')),);
const ChangePassword = Loadable(lazy(() => import('../pages/profile/ChangePassword')));

//------------------------------- Boggie -----------------------------------------------------

const BolsterStageInspection = Loadable(
  lazy(() => import('../pages/bogie/fabrication/BolsterStageInspection')),
);
const BlosterFinalStageInsReport = Loadable(
  lazy(() => import('../pages/bogie/fabrication/BlosterFinalStageInsReport')),
);
const BoggieFrameComplete = Loadable(
  lazy(() => import('../pages/bogie/fabrication/BoggieFrameComplete')),
);
const SideFrameStageInspection = Loadable(
  lazy(() => import('../pages/bogie/fabrication/SideFrameStageInspection')),
);
const BreakBeamInspection = Loadable(
  lazy(() => import('../pages/bogie/fabrication/BreakBeamInspection')),
);

const StageInspLineAssembly = Loadable(
  lazy(() => import('../pages/bogie/assembly/StageInspLineAssembly')),
);
const LoadTest5008B = Loadable(lazy(() => import('../pages/bogie/assembly/LoadtTest5008B')));

//-------------------------------- wheel shop -----------------------------------------------------------
const WheelStageOne = Loadable(lazy(() => import('../pages/wheel/WheelStageOne')));
const WheelStageTwo = Loadable(lazy(() => import('../pages/wheel/WheelStageTwo')));
const WheelStageTwoBreakDisc = Loadable(
  lazy(() => import('../pages/wheel/WheelStageTwoBreakDisc')),
);

const WheelStageThree = Loadable(lazy(() => import('../pages/wheel/WheelStageThree')));
const WheelStageFourAndFive = Loadable(lazy(() => import('../pages/wheel/WheelStageFourAndFive')));
const WheelStageSix = Loadable(lazy(() => import('../pages/wheel/WheelStageSix')));

//----------------------------------------Electrical------------------------------------------------------
const S3RoofPrecelling = Loadable(lazy(() => import('../pages/electrical/S3RoofPrecelling')));
const FinalQualityInspection = Loadable(
  lazy(() => import('../pages/electrical/FinalQualityInspection')),
);
const RMPUChecksheet = Loadable(lazy(() => import('../pages/electrical/RMPUChecksheet')));
const FinalSafety = Loadable(lazy(() => import('../pages/electrical/FinalSafety')));
const ElectricalshopDashboard = Loadable(
  lazy(() => import('../pages/dashboard/electricalShop/ElectricalshopDashboard')),
);
const AirDeliveryVBList = Loadable(lazy(() => import('../pages/electrical/VB/AirDeliveryVBList')));
const TractionView = Loadable(lazy(() => import('../pages/electrical/VB/TractionView')));
const TractionList = Loadable(lazy(() => import('../pages/electrical/VB/TractionList')));

//--------------------------------------------Furnishing---------------------------------------------------------
const FloorAndPvcList = Loadable(
  lazy(() => import('../pages/furnishing/StageAuditFormat/FloorAndPvcList')),
);
const PartitionList = Loadable(
  lazy(() => import('../pages/furnishing/StageAuditFormat/PartitionList')),
);
// const LuggageRackList = Loadable(
//   lazy(() => import('../pages/furnishing/StageAuditFormat/LuggageRackList')),
// );
const PannelingList = Loadable(
  lazy(() => import('../pages/furnishing/StageAuditFormat/PannelingList')),
);
const WindowAndCellingList = Loadable(
  lazy(() => import('../pages/furnishing/StageAuditFormat/WindowAndCellingList')),
);
const SeatAndBerthList = Loadable(
  lazy(() => import('../pages/furnishing/StageAuditFormat/SeatAndBerthList')),
);
const LavatoryList = Loadable(
  lazy(() => import('../pages/furnishing/StageAuditFormat/LavatoryList')),
);
const PlumbingList = Loadable(
  lazy(() => import('../pages/furnishing/StageAuditFormat/PlumbingList')),
);
const AirBrakeList = Loadable(
  lazy(() => import('../pages/furnishing/StageAuditFormat/AirBrakeList')),
);
const MouldingDoorsList = Loadable(
  lazy(() => import('../pages/furnishing/StageAuditFormat/MouldingDoorsList')),
);
const FurnishingQciList = Loadable(lazy(() => import('../pages/furnishing/qci/FurnishingQciList')));
const FireList = Loadable(lazy(() => import('../pages/furnishing/testing/FireList')));
const BufeerCbcList = Loadable(lazy(() => import('../pages/master/BufferCbcParamsListing')));
const BiotoiletList = Loadable(lazy(() => import('../pages/furnishing/testing/BiotoiletList')));
const BufferList = Loadable(lazy(() => import('../pages/furnishing/testing/BufferList')));
const LeakageList = Loadable(lazy(() => import('../pages/furnishing/testing/LeakageList')));
const FibaList = Loadable(lazy(() => import('../pages/furnishing/airBrake&Fiba/FibaList')));
const AirBrakeTestList = Loadable(
  lazy(() => import('../pages/furnishing/airBrake&Fiba/AirBrakeTestList')),
);
const IcDoorList = Loadable(lazy(() => import('../pages/furnishing/icDoors/icDoorsList')));
const DcouplingList = Loadable(
  lazy(() => import('../pages/furnishing/StageAuditFormat/VB/DCouplingList')),
);
const GangwayList = Loadable(
  lazy(() => import('../pages/furnishing/StageAuditFormat/VB/GangwayList')),
);
const PlugDoorList = Loadable(
  lazy(() => import('../pages/furnishing/StageAuditFormat/VB/PlugDoorList')),
);

const FloorBoardList = Loadable(
  lazy(() => import('../pages/furnishing/StageAuditFormat/VB/FloorBoardList')),
);
const FloorPvcList = Loadable(
  lazy(() => import('../pages/furnishing/StageAuditFormat/VB/FloorPvc/FloorPvcList')),
);
const GlasswoolList = Loadable(
  lazy(() => import('../pages/furnishing/StageAuditFormat/VB/GlasswoolList')),
);
const WindowList = Loadable(
  lazy(() => import('../pages/furnishing/StageAuditFormat/VB/WindowList')),
);
const PartitionVBList = Loadable(
  lazy(() => import('../pages/furnishing/StageAuditFormat/VB/PartitionVBList')),
);

const AcDuctList = Loadable(
  lazy(() => import('../pages/furnishing/StageAuditFormat/VB/AcDuct/AcDuctListing')),
);

// const QualityFrequencyFinalData = Loadable(lazy(() => import('../pages/report/QFRFinalQuality')));
const PanellingVBList = Loadable(
  lazy(() => import('../pages/furnishing/StageAuditFormat/VB/Panelling/PanellingVBList')),
);

const LavatoryVBList = Loadable(
  lazy(() => import('../pages/furnishing/StageAuditFormat/VB/Lavatory/LavatoryVBList')),
);

const SeatInspectionVBList = Loadable(
  lazy(() => import('../pages/furnishing/StageAuditFormat/VB/Seat/SeatInspectionVBList')),
);

const BiotoileVBtList = Loadable(
  lazy(() => import('../pages/furnishing/testing/VB/BiotoileVBtList')),
);

const AirBrakeTestVBList = Loadable(
  lazy(() => import('../pages/furnishing/testing/VB/AirBrakeTestVBList')),
);

//---------------------------------------------------------------------------------------------------------------

//clearance
const Clearance = Loadable(lazy(() => import('../pages/clearance/Clearance')));

//

// const Minimal = Loadable(lazy(() => import('../views/dashboards/Minimal')));
// const Analytical = Loadable(lazy(() => import('../views/dashboards/Analytical')));
// const Demographical = Loadable(lazy(() => import('../views/dashboards/Demographical')));
// const Modern = Loadable(lazy(() => import('../views/dashboards/Modern')));

/***** Apps ****/
const Notes = Loadable(lazy(() => import('../views/apps/notes/Notes')));
const Chat = Loadable(lazy(() => import('../views/apps/chat/Chat')));
const Contacts = Loadable(lazy(() => import('../views/apps/contacts/Contacts')));
const Calendar = Loadable(lazy(() => import('../views/apps/calendar/CalendarApp')));
const Email = Loadable(lazy(() => import('../views/apps/email/Email')));
const Shop = Loadable(lazy(() => import('../views/apps/ecommerce/Shop')));
const ShopDetail = Loadable(lazy(() => import('../views/apps/ecommerce/ShopDetail')));
const Treeview = Loadable(lazy(() => import('../views/apps/treeview/TreeView')));
const TicketList = Loadable(lazy(() => import('../views/apps/ticket/TicketList')));
const TicketDetail = Loadable(lazy(() => import('../views/apps/ticket/TicketDetail')));

/***** Ui Elements ****/
const Alerts = Loadable(lazy(() => import('../views/ui/Alerts')));
const Badges = Loadable(lazy(() => import('../views/ui/Badges')));
const Buttons = Loadable(lazy(() => import('../views/ui/Buttons')));
const Cards = Loadable(lazy(() => import('../views/ui/Cards')));
const Grid = Loadable(lazy(() => import('../views/ui/Grid')));
const Tables = Loadable(lazy(() => import('../views/ui/Tables')));
const Forms = Loadable(lazy(() => import('../views/ui/Forms')));
const Breadcrumbs = Loadable(lazy(() => import('../views/ui/Breadcrumbs')));
const Dropdowns = Loadable(lazy(() => import('../views/ui/DropDown')));
const BtnGroup = Loadable(lazy(() => import('../views/ui/BtnGroup')));
const Collapse = Loadable(lazy(() => import('../views/ui/Collapse')));
const ListGroup = Loadable(lazy(() => import('../views/ui/ListGroup')));
const Modal = Loadable(lazy(() => import('../views/ui/Modal')));
const Navbar = Loadable(lazy(() => import('../views/ui/Navbar')));
const Nav = Loadable(lazy(() => import('../views/ui/Nav')));
const Pagination = Loadable(lazy(() => import('../views/ui/Pagination')));
const Popover = Loadable(lazy(() => import('../views/ui/Popover')));
const Progress = Loadable(lazy(() => import('../views/ui/Progress')));
const Spinner = Loadable(lazy(() => import('../views/ui/Spinner')));
const Tabs = Loadable(lazy(() => import('../views/ui/Tabs')));
const Toasts = Loadable(lazy(() => import('../views/ui/Toasts')));
const Tooltip = Loadable(lazy(() => import('../views/ui/Tooltip')));

/***** Form Layout Pages ****/
const FormBasic = Loadable(lazy(() => import('../views/form-layouts/FormBasic')));
const FormGrid = Loadable(lazy(() => import('../views/form-layouts/FormGrid')));
const FormGroup = Loadable(lazy(() => import('../views/form-layouts/FormGroup')));
const FormInput = Loadable(lazy(() => import('../views/form-layouts/FormInput')));

/***** Form Pickers Pages ****/
const Datepicker = Loadable(lazy(() => import('../views/form-pickers/DateTimePicker')));
const TagSelect = Loadable(lazy(() => import('../views/form-pickers/TagSelect')));

/***** Form Validation Pages ****/
const FormValidate = Loadable(lazy(() => import('../views/form-validation/FormValidation')));
const FormSteps = Loadable(lazy(() => import('../views/form-steps/Steps')));
const FormEditor = Loadable(lazy(() => import('../views/form-editor/FormEditor')));
/***** Table Pages ****/
const Basictable = Loadable(lazy(() => import('../views/tables/TableBasic')));
const CustomReactTable = Loadable(lazy(() => import('../views/tables/CustomReactTable')));
const ReactBootstrapTable = Loadable(lazy(() => import('../views/tables/ReactBootstrapTable')));

/***** Chart Pages ****/
const ApexCharts = Loadable(lazy(() => import('../views/charts/ApexCharts')));
const ChartJs = Loadable(lazy(() => import('../views/charts/ChartJs')));

/***** Sample Pages ****/
const StarterKit = Loadable(lazy(() => import('../views/sample-pages/StarterKit')));
const Profile = Loadable(lazy(() => import('../views/sample-pages/Profile')));
const Gallery = Loadable(lazy(() => import('../views/sample-pages/Gallery')));
const SearchResult = Loadable(lazy(() => import('../views/sample-pages/SearchResult')));
const HelperClass = Loadable(lazy(() => import('../views/sample-pages/HelperClass')));

/***** Icon Pages ****/
const Bootstrap = Loadable(lazy(() => import('../views/icons/Bootstrap')));
const Feather = Loadable(lazy(() => import('../views/icons/Feather')));

/***** Map Pages ****/
const CustomVectorMap = Loadable(lazy(() => import('../views/maps/CustomVectorMap')));

/***** Widget Pages ****/
const Widget = Loadable(lazy(() => import('../views/widget/Widget')));

/***** CASL Access Control ****/
const CASL = Loadable(lazy(() => import('../views/apps/accessControlCASL/AccessControl')));

/***** Auth Pages ****/
const Error = Loadable(lazy(() => import('../views/auth/Error')));
const RegisterFormik = Loadable(lazy(() => import('../views/auth/RegisterFormik')));
const LoginFormik = Loadable(lazy(() => import('../views/auth/LoginFormik')));
const Maintanance = Loadable(lazy(() => import('../views/auth/Maintanance')));
const LockScreen = Loadable(lazy(() => import('../views/auth/LockScreen')));
const RecoverPassword = Loadable(lazy(() => import('../views/auth/RecoverPassword')));

/*****Routes******/

const ThemeRoutes = [
  {
    path: '/',
    element: <FullLayout />,
    children: [
      { path: '/', name: 'Home', element: <Navigate to="/auth/login" /> },
      // { path: '/', name: 'Home', element: <Navigate to="/dashboards/minimal" /> },
      // { path: '/dashboards/minimal', name: 'Minimal', exact: true, element: <Minimal /> },
      // { path: '/dashboards/analytical', name: 'Analytical', exact: true, element: <Analytical /> },
      // { path: '/dashboards/demographical', name: 'Demographical', exact: true, element: <Demographical /> },
      { path: '/dashboards', name: 'Modern', exact: true, element: <Dashboard /> },
      { path: '/apps/notes', name: 'notes', exact: true, element: <Notes /> },
      { path: '/apps/chat', name: 'chat', exact: true, element: <Chat /> },
      { path: '/apps/contacts', name: 'contacts', exact: true, element: <Contacts /> },
      { path: '/apps/calendar', name: 'calendar', exact: true, element: <Calendar /> },
      { path: '/apps/email', name: 'email', exact: true, element: <Email /> },
      { path: '/ecom/shop', name: 'email', exact: true, element: <Shop /> },
      { path: '/ecom/shopdetail', name: 'email', exact: true, element: <ShopDetail /> },
      { path: '/tickt/ticket-list', name: 'ticket list', exact: true, element: <TicketList /> },
      {
        path: '/tickt/ticket-detail',
        name: 'ticket detail',
        exact: true,
        element: <TicketDetail />,
      },
      { path: '/apps/treeview', name: 'email', exact: true, element: <Treeview /> },
      { path: '/ui/alerts', name: 'alerts', exact: true, element: <Alerts /> },
      { path: '/ui/badges', name: 'badges', exact: true, element: <Badges /> },
      { path: '/ui/buttons', name: 'buttons', exact: true, element: <Buttons /> },
      { path: '/ui/cards', name: 'cards', exact: true, element: <Cards /> },
      { path: '/ui/grid', name: 'grid', exact: true, element: <Grid /> },
      { path: '/ui/table', name: 'table', exact: true, element: <Tables /> },
      { path: '/ui/forms', name: 'forms', exact: true, element: <Forms /> },
      { path: '/ui/breadcrumbs', name: 'breadcrumbs', exact: true, element: <Breadcrumbs /> },
      { path: '/ui/dropdown', name: 'dropdown', exact: true, element: <Dropdowns /> },
      { path: '/ui/button-group', name: 'button group', exact: true, element: <BtnGroup /> },
      { path: '/ui/collapse', name: 'collapse', exact: true, element: <Collapse /> },
      { path: '/ui/list-group', name: 'list-group', exact: true, element: <ListGroup /> },
      { path: '/ui/modal', name: 'modal', exact: true, element: <Modal /> },
      { path: '/ui/navbar', name: 'navbar', exact: true, element: <Navbar /> },
      { path: '/ui/nav', name: 'nav', exact: true, element: <Nav /> },
      { path: '/ui/pagination', name: 'pagination', exact: true, element: <Pagination /> },
      { path: '/ui/popover', name: 'popover', exact: true, element: <Popover /> },
      { path: '/ui/progress', name: 'progress', exact: true, element: <Progress /> },
      { path: '/ui/spinner', name: 'spinner', exact: true, element: <Spinner /> },
      { path: '/ui/tabs', name: 'tabs', exact: true, element: <Tabs /> },
      { path: '/ui/toasts', name: 'toasts', exact: true, element: <Toasts /> },
      { path: '/ui/tooltip', name: 'tooltip', exact: true, element: <Tooltip /> },
      { path: '/form-layout/form-basic', name: 'form-basic', exact: true, element: <FormBasic /> },
      { path: '/form-layout/form-grid', name: 'form-grid', exact: true, element: <FormGrid /> },
      { path: '/form-layout/form-group', name: 'form-group', exact: true, element: <FormGroup /> },
      { path: '/form-layout/form-input', name: 'form-input', exact: true, element: <FormInput /> },
      {
        path: '/form-pickers/datepicker',
        name: 'datepicker',
        exact: true,
        element: <Datepicker />,
      },
      { path: '/form-pickers/tag-select', name: 'tag-select', exact: true, element: <TagSelect /> },
      { path: '/form-validation', name: 'form-validation', exact: true, element: <FormValidate /> },
      { path: '/form-steps', name: 'form-steps', exact: true, element: <FormSteps /> },
      { path: '/form-editor', name: 'form-editor', exact: true, element: <FormEditor /> },

      { path: '/tables/basic-table', name: 'basic-table', exact: true, element: <Basictable /> },
      {
        path: '/tables/react-table',
        name: 'react-table',
        exact: true,
        element: <CustomReactTable />,
      },
      {
        path: '/tables/data-table',
        name: 'data-table',
        exact: true,
        element: <ReactBootstrapTable />,
      },
      { path: '/charts/apex', name: 'apex', exact: true, element: <ApexCharts /> },
      { path: '/charts/chartjs', name: 'chartjs', exact: true, element: <ChartJs /> },
      { path: '/sample-pages/profile', name: 'profile', exact: true, element: <Profile /> },
      {
        path: '/sample-pages/helper-class',
        name: 'helper-class',
        exact: true,
        element: <HelperClass />,
      },
      {
        path: '/sample-pages/starterkit',
        name: 'starterkit',
        exact: true,
        element: <StarterKit />,
      },
      { path: '/sample-pages/gallery', name: 'gallery', exact: true, element: <Gallery /> },
      {
        path: '/sample-pages/search-result',
        name: 'search-result',
        exact: true,
        element: <SearchResult />,
      },
      { path: '/icons/bootstrap', name: 'bootstrap', exact: true, element: <Bootstrap /> },
      { path: '/icons/feather', name: 'feather', exact: true, element: <Feather /> },
      { path: '/map/vector', name: 'vector', exact: true, element: <CustomVectorMap /> },
      { path: '/widget', name: 'widget', exact: true, element: <Widget /> },
      { path: '/casl', name: 'casl', exact: true, element: <CASL /> },

      //--------------------------------- real time routes --------------------------------------------
      {
        path: '/master/roof-dim-obs-list',
        name: 'roof-dms-list',
        exact: true,
        element: <RoofDimensionList />,
      },
      {
        path: '/master/uf-dim-obs-param-list',
        name: 'material-list',
        exact: true,
        element: <MaterialList />,
      },
      {
        path: '/master/uf-visual-obs-param-list',
        name: 'uf-visual-obs',
        exact: true,
        element: <UfVisualOBS />,
      },

      {
        path: '/master/uf-cross-member-distance-center-line',
        name: 'uf-cross-member-distance-center-line',
        exact: true,
        element: <UfCrossMember />,
      },
      {
        path: '/master/uf-component-names',
        name: 'uf-component-names',
        exact: true,
        element: <UfComponentNames />,
      },
      {
        path: '/master/uf-machine-names',
        name: 'uf-machine-names',
        exact: true,
        element: <UfMachineNames />,
      },
      {
        path: '/master/uf-operation-names',
        name: 'uf-machine-names',
        exact: true,
        element: <UfOperationNames />,
      },
      {
        path: '/master/uf-operations',
        name: 'uf-operations',
        exact: true,
        element: <UfOperations />,
      },
      { path: '/metal-sheet', name: 'metal-sheet', exact: true, element: <MetalSheetList /> },
      {
        path: '/role-permission',
        name: 'role-permission',
        exact: true,
        element: <RolePermissionList />,
      },
      { path: '/roles-edit/:id', name: 'role-edit', exact: true, element: <RolePermissionEdit /> },
      { path: '/stage-one-list', name: 'stage-one-list', exact: true, element: <StageOneList /> },
      {
        path: '/master/uf-frametypes',
        name: 'uf-frametypes',
        exact: true,
        element: <UfFrameTypes />,
      },
      { path: '/master/instruments', name: 'instruments', exact: true, element: <Instruments /> },
      { path: '/stage-two-list', name: 'stage-two-list', exact: true, element: <StageTwoList /> },
      {
        path: '/master/drg-number',
        name: 'drg-number',
        exact: true,
        element: <DrgNumbers />,
      },
      {
        path: '/master/train-type',
        name: 'uf-train-type',
        exact: true,
        element: <UfTrainType />,
      },
      {
        path: '/master/visual-type',
        name: 'visual-type',
        exact: true,
        element: <VisualType />,
      },
      {
        path: '/master/daily-turnout-report',
        name: 'uf-visual-obs',
        exact: true,
        element: <DailyTurnOutReport />,
      },

      {
        path: '/master/cr-position-form',
        name: 'master-cr-position',
        exact: true,
        element: <CrPositionForm />,
      },
      {
        path: '/report/daily-dispatch-form',
        name: 'report-daily-dispatch-form',
        exact: true,
        element: <DailyDispatchReport />,
      },

      {
        path: '/user-list',
        name: 'user-list',
        exact: true,
        element: <UserList />,
      },
      {
        path: '/final-inspection',
        name: 'final-inspection',
        exact: true,
        element: <FinalInspectionList />,
      },

      {
        path: '/roof/stage-one-list',
        name: 'roof-stage-one-list',
        exact: true,
        element: <RoofStageOneList />,
      },
      {
        path: '/roof/stage-two-list',
        name: 'roof-stage-two-list',
        exact: true,
        element: <RoofStageTwoList />,
      },
      {
        path: '/roof/stage-three-list',
        name: 'roof-stage-three-list',
        exact: true,
        element: <RoofStageThreeList />,
      },
      {
        path: '/end-wall/stage-one-list',
        name: 'end-wall-stage-one-list',
        exact: true,
        element: <EndWallStageOneList />,
      },
      {
        path: '/end-wall/stage-two-list',
        name: 'end-wall-stage-one-list',
        exact: true,
        element: <EndWallStageTwoList />,
      },
      {
        path: '/side-wall/stage-one-list',
        name: 'side-wall-stage-one-list',
        exact: true,
        element: <SideWallStageOneList />,
      },
      {
        path: '/side-wall/stage-two-list',
        name: 'side-wall-stage-two-list',
        exact: true,
        element: <SideWallStageTwoList />,
      },
      {
        path: '/side-wall/stage-three-list',
        name: 'side-wall-stage-three-list',
        exact: true,
        element: <SideWallStageThreeList />,
      },
      {
        path: '/assembly/stage-one-list',
        name: 'assembly-stage-one-list',
        exact: true,
        element: <AssemblyStageOneList />,
      },
      {
        path: '/assembly/stage-three-list',
        name: 'assembly-stage-three-list',
        exact: true,
        element: <AssemblyStageThreeList />,
      },
      { path: '/shell-dashboard', name: 'Modern', exact: true, element: <ShellDashboard /> },

      { path: '/bogie-dashboard', name: 'Modern', exact: true, element: <BogieDashboard /> },
      { path: '/wheel-dashboard', name: 'Modern', exact: true, element: <WheelDashboard /> },
      {
        path: '/furnishing-dashboard',
        name: 'Modern',
        exact: true,
        element: <FurnishingDashboard />,
      },

      {
        path: '/paint-list',
        name: 'paint-list',
        exact: true,
        element: <PaintList />,
      },
      {
        path: '/paint-shop-report',
        name: 'paint-shop-report',
        exact: true,
        element: <PaintShopReport />,
      },

      {
        path: '/paint-insulation-list',
        name: 'paint-insulation-list',
        exact: true,
        element: <PaintInsulationList />,
      },

      {
        path: '/report-list',
        name: 'report-list',
        exact: true,
        element: <ReportList />,
      },
      {
        path: '/shell-report',
        name: 'shell-report',
        exact: true,
        element: <ShellReport />,
      },
      {
        path: '/monthly-report-list',
        name: 'monthly-report-list',
        exact: true,
        element: <MonthlyReportList />,
      },
       {
        path: '/monthly-inspection-report-list',
        name: 'monthly-inspection-report-list',
        exact: true,
        element: <MonthlyInspectionReport />,
      },
      {
        path: '/cr-position-list',
        name: 'cr-position-list',
        exact: true,
        element: <CrPositionReportList />,
      },
      {
        path: '/bogie-position-report',
        name: 'Bogie Position Report',
        exact: true,
        element: <AddDefectForm />,
      },
      {
        path: '/backlog-list',
        name: ' backlog-list',
        exact: true,
        element: <BacklogReportList />,
      },
      {
        path: '/daily-report/front-part',
        name: 'daily-report',
        exact: true,
        element: <FrontPart />,
      },
      {
        path: '/daily-report/shower-testing',
        name: 'daily-report',
        exact: true,
        element: <ShowerTesting />,
      },
      {
        path: '/wheel-report',
        name: 'wheel-report',
        exact: true,
        element: <WheelReport />,
      },
      {
        path: '/si-shell-report',
        name: 'si-shell-report',
        exact: true,
        element: <StageInspectionShellReport />,
      },

      {
        path: '/fabrication/bolster-si-list',
        name: 'bolster-stage-inspection',
        exact: true,
        element: <BolsterStageInspection />,
      },
      {
        path: '/assembly/stage-insp-line-assembly',
        name: 'bolster-stage-inspection',
        exact: true,
        element: <StageInspLineAssembly />,
      },
      {
        path: '/assembly/static-load-test',
        name: 'bolster-stage-inspection',
        exact: true,
        element: <LoadTest5008B />,
      },
      {
        path: '/fabrication/bolster-fi-list',
        name: 'bolster-fi-list',
        exact: true,
        element: <BlosterFinalStageInsReport />,
      },
      {
        path: '/fabrication/bogie-frame-list',
        name: 'bolster-fi-list',
        exact: true,
        element: <BoggieFrameComplete />,
      },
      {
        path: '/fabrication/side-frame-list',
        name: 'bolster-fi-list',
        exact: true,
        element: <SideFrameStageInspection />,
      },
      {
        path: '/fabrication/break-beam-list',
        name: 'bolster-fi-list',
        exact: true,
        element: <BreakBeamInspection />,
      },
      {
        path: '/wheel-shop/stage-one',
        name: 'wheel-stage-one',
        exact: true,
        element: <WheelStageOne />,
      },
      {
        path: '/wheel-shop/stage-two',
        name: 'wheel-stage-two',
        exact: true,
        element: <WheelStageTwo />,
      },
      {
        path: '/wheel-shop/stage-two-brakedisc-list',
        name: 'stage-two-brakedisc-list',
        exact: true,
        element: <WheelStageTwoBreakDisc />,
      },
      {
        path: '/wheel-shop/stage-three',
        name: 'wheel-stage-three',
        exact: true,
        element: <WheelStageThree />,
      },
      {
        path: '/wheel-shop/stage-four-and-five',
        name: 'wheel-stage-four-and-five',
        exact: true,
        element: <WheelStageFourAndFive />,
      },
      {
        path: '/wheel-shop/stage-six',
        name: 'wheel-stage-six',
        exact: true,
        element: <WheelStageSix />,
      },
      {
        path: '/electrical-dashboard',
        name: 'Electrical Dashboard',
        exact: true,
        element: <ElectricalshopDashboard />,
      },
      {
        path: '/electrical/roof-precelling',
        name: 'roof-precelling',
        exact: true,
        element: <S3RoofPrecelling />,
      },
      {
        path: '/electrical/final-quality-inspection',
        name: 'final-quality-inspection',
        exact: true,
        element: <FinalQualityInspection />,
      },
      {
        path: '/electrical/rmpu-check-sheet',
        name: 'rmpu-check-sheet',
        exact: true,
        element: <RMPUChecksheet />,
      },
      {
        path: '/electrical/fine-safety',
        name: 'fine-safety',
        exact: true,
        element: <FinalSafety />,
      },

      {
        path: '/electrical/air-delivery-list',
        name: 'air-delivery-list',
        exact: true,
        element: <AirDeliveryVBList />,
      },
      
      {
        path: '/electrical/traction-view',
        name: 'traction-view',
        exact: true,
        element: <TractionView />,
      },

      {
        path: '/electrical/traction-list',
        name: 'traction-list',
        exact: true,
        element: <TractionList />,
      },
      
     
      {
        path: '/clearence-list',
        name: 'clearence-list',
        exact: true,
        element: <Clearance />,
      },
      {
        path: '/furnishing/floor-and-pve-list',
        name: 'floor-and-pve-list',
        exact: true,
        element: <FloorAndPvcList />,
      },
      {
        path: '/furnishing/partition-list',
        name: 'partition-list',
        exact: true,
        element: <PartitionList />,
      },
      {
        path: '/furnishing/luggage-rack-list',
        name: 'luggage-rack-list',
        exact: true,
        element: <LuggageRackList />,
      },
      {
        path: '/furnishing/panneling-list',
        name: 'panneling-list',
        exact: true,
        element: <PannelingList />,
      },
      {
        path: '/furnishing/window-and-celling-list',
        name: 'window-and-celling-list',
        exact: true,
        element: <WindowAndCellingList />,
      },
      {
        path: '/furnishing/seat-and-berth-list',
        name: 'seat-and-berth-list',
        exact: true,
        element: <SeatAndBerthList />,
      },
      {
        path: '/furnishing/lavatory-list',
        name: 'lavatory-list',
        exact: true,
        element: <LavatoryList />,
      },
      {
        path: '/furnishing/plumbing-list',
        name: 'plumbing-list',
        exact: true,
        element: <PlumbingList />,
      },
      {
        path: '/furnishing/air-brake-list',
        name: 'air-brake-list',
        exact: true,
        element: <AirBrakeList />,
      },
      {
        path: '/furnishing/moulding-doors-list',
        name: 'moulding-doors-list',
        exact: true,
        element: <MouldingDoorsList />,
      },
      {
        path: '/furnishing/furnishing-qci',
        name: 'furnishing-qci',
        exact: true,
        element: <FurnishingQciList />,
      },
      {
        path: '/furnishing/fire-list',
        name: 'fire-list',
        exact: true,
        element: <FireList />,
      },
      {
        path: '/master/buffer-cbc-obs-list',
        name: 'fire-list',
        exact: true,
        element: <BufeerCbcList />,
      },
      {
        path: '/furnishing/biotoilet',
        name: 'biotoilet',
        exact: true,
        element: <BiotoiletList />,
      },
      {
        path: '/furnishing/buffer-list',
        name: 'buffer-list',
        exact: true,
        element: <BufferList />,
      },
      // 2. LHB route
      {
        path: '/furnishing/buffer-list/lhb',
        name: 'buffer-list-lhb',
        exact: true,
        element: <BufferList coachType="lhb" />,
      },
      // 3. Vande Bharat route
      {
        path: '/furnishing/buffer-list/vende-bharat',
        name: 'buffer-list-vende-bharat',
        exact: true,
        element: <BufferList coachType="vende-bharat" />,
      },
      {
        path: '/furnishing/fiba-list',
        name: 'fiba-list',
        exact: true,
        element: <FibaList />,
      },
      {
        path: '/furnishing/air-brake-test-list',
        name: 'fiba-list',
        exact: true,
        element: <AirBrakeTestList />,
      },
      {
        path: '/furnishing/leakage-list',
        name: 'fiba-list',
        exact: true,
        element: <LeakageList />,
      },
      {
        path: '/furnishing/ic-doors-list',
        name: 'ic-door-list',
        exact: true,
        element: <IcDoorList />,
      },
      {
        path: '/furnishing/plug-door-list',
        name: 'plug-door-list',
        exact: true,
        element: <PlugDoorList />,
      },
      {
        path: '/furnishing/biotoilet/vende-bharat',
        name: 'biotoilet-vende-bharat',
        exact: true,
        element: <BiotoileVBtList />,
      },

      {
        path: '/furnishing/air-brake-test-list/vende-bharat',
        name: 'air-brake-test-list-vende-bharat',
        exact: true,
        element: <AirBrakeTestVBList />,
      },

      {
        path: '/furnishing/floor-board-inspection-list',
        name: 'floor-board-inspection-list',
        exact: true,
        element: <FloorBoardList />,
      },
      {
        path: '/furnishing/floor-pvc-inspection-list',
        name: 'floor-pvc-inspection-list',
        exact: true,
        element: <FloorPvcList />,
      },
      {
        path: '/furnishing/d-coupling-inspection-list',
        name: 'd-coupling-inspection-list',
        exact: true,
        element: <DcouplingList />,
      },
      {
        path: '/furnishing/gangway-inspection-list',
        name: 'gangway-inspection-list',
        exact: true,
        element: <GangwayList />,
      },
      {
        path: '/furnishing/glass-wool-inspection-list',
        name: 'glass-wool-inspection-list',
        exact: true,
        element: <GlasswoolList />,
      },
      {
        path: '/furnishing/window-inspection-list',
        name: 'window-inspection-list',
        exact: true,
        element: <WindowList />,
      },

      {
        path: '/furnishing/partition-inspection-list',
        name: 'partition-inspection-list',
        exact: true,
        element: <PartitionVBList />,
      },
      {
        path: '/furnishing/ac-duct-inspection-list',
        name: 'ac-duct-inspection-list',
        exact: true,
        element: <AcDuctList />,
      },
      {
        path: '/furnishing/panelling-inspection-list',
        name: 'panelling-inspection-list',
        exact: true,
        element: <PanellingVBList />,
      },

      {
        path: '/furnishing/lavatory-inspection-list',
        name: 'lavatory-inspection-list',
        exact: true,
        element: <LavatoryVBList />,
      },

      {
        path: '/furnishing/seat-inspection-list',
        name: 'seat-inspection-list',
        exact: true,
        element: <SeatInspectionVBList />,
      },

      {
        path: '/quality-frequency-list',
        name: 'quality-frequency-list',
        exact: true,
        element: <QFRPreceilingList />,
      },
      {
        path: '/quality-final-list',
        name: 'quality-final-list',
        exact: true,
        element: <QFRFinalQualityList />,
      },
      {
        path: '/daily-report/lav-side-wall',
        name: 'daily-report-lav-side-wall',
        exact: true,
        element: <LavSideWall />,
      },
      {
        path: '/shell-vital-points-report',
        name: 'shell-vital-points-report',
        exact: true,
        element: <ShellVitalPointsReport />,
      },
      {
        path: '/change-password',
        name: 'change-password',
        exact: true,
        element: <ChangePassword />,
      },

     

      //-----------------------------------------------------------------------------------------------

      { path: '*', element: <Navigate to="/auth/404" /> },
      {
        path: '/dashboard/paintshop',
        element: <PaintshopDashboard />,
      },
    ],
  },
  {
    path: '/auth',
    element: <BlankLayout />,
    children: [
      { path: 'login', element: <Login /> },
      { path: '404', element: <Error /> },
      { path: '*', element: <Navigate to="/auth/404" /> },
      { path: 'forgotpassword', element: <ForgotPassword /> },

      { path: 'registerformik', element: <RegisterFormik /> },
      { path: 'loginformik', element: <LoginFormik /> },
      { path: 'maintanance', element: <Maintanance /> },
      { path: 'lockscreen', element: <LockScreen /> },
      { path: 'recoverpwd', element: <RecoverPassword /> },
    ],
  },
  {
    path: '/add-defect-test',
    element: <AddDefectTestPage />,
  },
];

export default ThemeRoutes;
